// import React, { useEffect, useState } from "react";
// import { Navigate } from "react-router-dom";
// import { setAuthorization } from "../helpers/api_helper";
// // import { useDispatch } from "react-redux";
// import { useProfile } from "../Components/Hooks/UserHooks";
// import { logoutUser } from "../slices/auth/login/thunk";
// import { useAppDispatch } from "../store/hooks";


// const AuthProtected = ({ children }: { children: React.ReactNode }) => {
//   const dispatch = useAppDispatch();


//   const { isAuthenticated, loading } = useProfile();

//   console.log(isAuthenticated)

//   const [shouldRedirect, setShouldRedirect] = useState(false);
//   console.log("condition......",isAuthenticated, loading)

//   useEffect(() => {
//     if (!loading && !isAuthenticated) {
//       dispatch(logoutUser());
//       setShouldRedirect(true);
//     }
//   }, [loading, isAuthenticated, dispatch]);

//   if (shouldRedirect) {
//     return <Navigate to="/login" replace />;
//   }

//   return <>{children}</>;
// };

// export default AuthProtected;




import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { fetchLoggedInUser } from "services/authServcies";

const AuthProtected = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useAppDispatch();
  const { isAuthenticated, loading } = useAppSelector(state => state.Login);
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    // const isLoggedIn = sessionStorage.getItem("isLoggedIn");

    // if (isLoggedIn && !isAuthenticated) {
    //   dispatch(fetchLoggedInUser()).finally(() => setHydrated(true));
    // } else {
    //   setHydrated(true);
    // }
    const authUser = sessionStorage.getItem("authUser");
  
    if (authUser && !isAuthenticated) {
      dispatch(fetchLoggedInUser()).finally(() => setHydrated(true));
    } else {
      setHydrated(true);
    }
  }, [dispatch, isAuthenticated]);

  // Wait until Redux is hydrated
  if (!hydrated || loading) return null;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default AuthProtected;

